module.exports = __webpack_public_path__ + "img/welcome.5d4eae67.svg";